// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1aoJS","insightsList":"newBusinessInsightsMenu_insightsList__etDaj","active":"newBusinessInsightsMenu_active__1pBWb"};